import { useEffect, useRef } from "react";

export const useReturnToTopTrigger = ({ enabled, timeout, triggerChat }) => {
  const hasScrolledHalfway = useRef(false);
  const hasTimeoutStarted = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const halfwayPoint =
        (document.documentElement.scrollHeight - window.innerHeight) / 2;

      // Track if user has scrolled halfway down
      if (scrollPosition >= halfwayPoint) {
        hasScrolledHalfway.current = true;
      }

      // If user scrolled halfway and is now back at top, trigger chat
      if (hasScrolledHalfway.current && scrollPosition === 0) {
        if (hasTimeoutStarted.current) return;
        hasTimeoutStarted.current = true;
        setTimeout(() => {
          triggerChat("Scrolled Back To Top");
        }, timeout * 1000);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [enabled, timeout, triggerChat]);
};
